import { Directive, Input, TemplateRef, ViewContainerRef, inject } from '@angular/core';

import { IdentityProviderFactory } from 'ish-core/identity-provider/identity-provider.factory';
import { IdentityProviderCapabilities } from 'ish-core/identity-provider/identity-provider.interface';

@Directive({ selector: '[ishIdentityProviderCapability]' })
export class IdentityProviderCapabilityDirective {
  private templateRef = inject<TemplateRef<unknown>>(TemplateRef);
  private viewContainer = inject(ViewContainerRef);
  private identityProviderFactory = inject(IdentityProviderFactory);

  @Input() set ishIdentityProviderCapability(val: keyof IdentityProviderCapabilities) {
    const enabled = this.identityProviderFactory.getInstance().getCapabilities()[val];

    if (enabled) {
      this.viewContainer.createEmbeddedView(this.templateRef);
    } else {
      this.viewContainer.clear();
    }
  }
}
